<core-popover-overlay-window header="Feedback zur Antwort"
                             [popoverRef]="popover"
                             [submitDisabled]="!selected.length"
                             (submitted)="feedbackSubmitted.emit(selected)">
  <app-feedback-chips (selectedChanged)="selected = $event"></app-feedback-chips>
</core-popover-overlay-window>
